import React from 'react'

export default () => (
  <svg className='edit-icon' width='18' height='18' viewBox='0 0 18 18'>
    <title>Edit Icon</title>
    <path fill='#fff' d='M18 8h-8V0H8v8H0v2h8v8h2v-8h8z' />
  </svg>
)
